var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38878 1.43893C8.85517 0.663949 9.97873 0.663951 10.4451 1.43893L12.4738 4.80997C12.6414 5.08838 12.9147 5.28694 13.2313 5.36026L17.0642 6.24798C17.9454 6.45206 18.2926 7.52062 17.6996 8.20367L15.1205 11.1748C14.9075 11.4202 14.8031 11.7415 14.8312 12.0652L15.1714 15.9849C15.2496 16.886 14.3406 17.5464 13.5078 17.1936L9.88506 15.6588C9.58586 15.532 9.24804 15.532 8.94884 15.6588L5.32613 17.1936C4.49329 17.5464 3.58432 16.886 3.66252 15.9849L4.0027 12.0652C4.03079 11.7415 3.9264 11.4202 3.71339 11.1748L1.13426 8.20367C0.541325 7.52062 0.888524 6.45206 1.7697 6.24798L5.60265 5.36026C5.91921 5.28694 6.19251 5.08838 6.36006 4.80997L8.38878 1.43893Z",
    fill: "#1F2024",
    stroke: "#1F2024",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.eaae30b3d43976e74dfea82aae84c2ee.svg";
export { ForwardRef as ReactComponent };